import { SYSTEM_NOTIFICATIONS_CONFIG_NAME } from '../constants';
import type { SystemNotificationsConfig } from '../types';

import { trackNotificationFetchError } from './trackNotificationError';

const STATSIG_API_URL = 'https://api.statsig.com/v1/get_config';

/**
 * Fetch system notifications config directly from Statsig REST API.
 * This bypasses the Statsig SDK entirely to avoid any shared state or re-renders.
 */
export async function fetchNotificationConfig(): Promise<SystemNotificationsConfig | undefined> {
  const sdkKey = import.meta.env.VITE_STATSIG_SDK_KEY as string;
  if (!sdkKey) {
    console.warn('[SystemNotifications] Statsig SDK key not found. Notifications will be disabled.');
    return undefined;
  }

  try {
    const response = await fetch(STATSIG_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'statsig-api-key': sdkKey,
      },
      body: JSON.stringify({
        configName: SYSTEM_NOTIFICATIONS_CONFIG_NAME,
        user: {},
        statsigMetadata: {
          sdkType: 'custom-http-client',
          sdkVersion: '1.0.0',
          exposureLoggingDisabled: true, // Don't log exposures for polling
        },
      }),
    });

    if (!response.ok) {
      const errorMessage = `Failed to fetch config: ${response.status} ${response.statusText}`;
      trackNotificationFetchError(errorMessage, response.status);
      return undefined;
    }

    const data = await response.json();
    return data.value as SystemNotificationsConfig;
  } catch (e) {
    const error = e instanceof Error ? e : new Error(String(e));
    trackNotificationFetchError(error);
    return undefined;
  }
}
